<template>
  <div class="newcenter-detail">
    <div class="detail-content">
      <div class="detail-content-head">
        <div>
          {{this.navList[this.infoIndex].title}}
        </div>
        <div>{{this.navList[this.infoIndex].releaseDate}}</div>
      </div>
      <div class="detail-content-main">
        <div v-html="this.navList[this.infoIndex].contents"></div>
      </div>
      <div class="detail-content-foot">
        <div @click="toLast">上一篇：<span>{{this.navList[this.lastIndex].title}}</span></div>
        <div @click="toNext">下一篇：<span>{{this.navList[this.nextIndex].title}}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navList:[],
      infoIndex: 0,
      item: {},
      nextIndex:0,
      lastIndex:0
    };
  },
  mounted() {
    this.infoIndex = this.$route.query.infoIndex;
    this.navList = JSON.parse(localStorage.getItem('navList')) 
    this.queryFundNewById(this.navList[this.infoIndex].id)
    if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    
  },
  
  methods: {
    queryFundNewById(id) {
      let params = {
        id: id,
      };
      this.$API.queryFundNewById(params);
    },
    //上一页
    toLast(){
      this.infoIndex = this.lastIndex
      if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    },
    //下一页
    toNext(){
      this.infoIndex = this.nextIndex
      if(this.infoIndex == 0){
      this.lastIndex = this.infoIndex 
    }else{
      this.lastIndex = parseInt(this.infoIndex) - 1
    }
    if(this.infoIndex  == this.navList.length - 1){
       this.nextIndex = this.infoIndex 
    }else{
       this.nextIndex = parseInt(this.infoIndex) + 1
    }
    },

  },
};
</script>
<style lang="scss" scoped>
.newcenter-detail {
  width: 100%;
}
.detail-content {
  width: 1200px;
  margin: 0 auto;
}
.detail-content-head {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-top: 40px;
  > :nth-child(1) {
    font-size: 20px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 700;
    color: #333333;
  }
  > :nth-child(2) {
    font-size: 13px;
    font-family: MicrosoftYaHei, MicrosoftYaHei-Bold;
    font-weight: 400;
    color: #777777;
    margin-top: 10px;
  }
}
.detail-content-main {
  padding: 37px 0 20px 0;
  border-bottom: 1px solid #efefef;
}
.detail-content-foot {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
  padding-bottom: 60px;
  > div:nth-child(1) {
    &:hover {
      color: #c1141e;
      cursor: pointer;
    }
  }
  > div:nth-child(2) {
    &:hover {
      color: #c1141e;
      cursor: pointer;
    }
  }
}
</style>